import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { GenericModal } from '@org/ui';
import { JourneyMultiStepForm } from '../../app/components/journey/journey-multi-step-form';
import { trpc } from '@org/clients/school';
import { unwrapTrpcData } from '@org/ui';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/journeys/$journeyId')({
  component: JourneyDetailRoute,
});

function JourneyDetailRoute() {
  const { journeyId } = Route.useParams();
  const navigate = useNavigate({ from: '/journeys/$journeyId' });
  const utils = trpc.useUtils();
  const { t } = useTranslation('admin');
  const { data, isLoading } = trpc.journeys.get.useQuery({ id: journeyId });
  const journey = unwrapTrpcData(data);

  const handleClose = () => {
    navigate({ to: '/journeys', replace: true });
  };

  const handleSubmit = async () => {
    await utils.journeys.list.invalidate();
    handleClose();
  };

  return (
    <GenericModal
      show
      onClose={handleClose}
      title={t('journeys.list.modal.editTitle')}
      size="xl"
      centered
      body={
        isLoading ? (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('journeys.form.loadingJourney')}
          </div>
        ) : journey ? (
          <JourneyMultiStepForm
            defaultValues={journey}
            onSubmit={handleSubmit}
            onClose={handleClose}
            isEditing
          />
        ) : (
          <div className="flex h-40 items-center justify-center text-muted-foreground">
            {t('journeys.form.notFound')}
          </div>
        )
      }
      footer={<></>}
    />
  );
}


